/*
 *                     NOTICE
 *            COPYRIGHT 2024 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 * 
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */
/* eslint-disable i18next/no-literal-string */ // Only shown in development mode

import { AbHSeparator } from "abreact/layout/AbHSeparator";
import { AbVBox } from "abreact/layout/AbVBox";
import { AbWebServices } from "abweb/service/AbWebServices";
import * as React from "react";
export const DISABLE_DEPRECATION = process.env.NODE_ENV !== "development";
export const getDeprecatedImageStyle = () => {
  const icon = DISABLE_DEPRECATION ? "absdk:transparent" : "absdk:error-12px";
  const identifierInfo = AbWebServices.getImageIdentifierManager().getIdentifierInfo(icon);
  return {
    "--ab-deprecated-background-image": `url(${identifierInfo.scales[0].path}`
  };
};
export const getDeprecatedTooltip = (tooltip, deprecatedTooltipProps) => {
  if (DISABLE_DEPRECATION) return tooltip;
  const migrationNode = /*#__PURE__*/React.createElement("div", {
    className: "ab-deprecated-tooltip"
  }, /*#__PURE__*/React.createElement("p", {
    className: "ab-deprecated-tooltip-title ab-font-heading-small"
  }, "Deprecated Component"), /*#__PURE__*/React.createElement("p", null, "This component found at ", /*#__PURE__*/React.createElement("span", {
    className: "ab-deprecated-tooltip-path"
  }, deprecatedTooltipProps.currentPath), " is deprecated. Please replace it with the component at ", /*#__PURE__*/React.createElement("span", {
    className: "ab-deprecated-tooltip-path"
  }, deprecatedTooltipProps.newPath)), deprecatedTooltipProps.migrationHelp && /*#__PURE__*/React.createElement("p", null, deprecatedTooltipProps.migrationHelp), /*#__PURE__*/React.createElement("p", null, "If the new component does not meet your use case, contact ", deprecatedTooltipProps.contact, "."), /*#__PURE__*/React.createElement("p", null, "Note: This deprecated icon/styling/tooltip is only shown in development mode."));
  if (!tooltip) return migrationNode;
  return /*#__PURE__*/React.createElement(AbVBox, null, migrationNode, /*#__PURE__*/React.createElement(AbHSeparator, null), /*#__PURE__*/React.createElement("div", null, tooltip));
};
//# sourceMappingURL=AbDeprecatedIndicator.js.map
